import { useCallback } from 'react';
import { fetchDashboardGerencial } from '@/services/dashboards.js';
import { useDashboardResource } from '@/hooks/useDashboardResource.js';

const REFRESH_MS = 5 * 60_000;

export function useDashboardData({ sucursalId } = {}) {
  const fetcher = useCallback(() => fetchDashboardGerencial({ sucursalId }), [sucursalId]);
  return useDashboardResource(fetcher, {
    refreshMs: REFRESH_MS,
    errorFallback: 'No se pudo cargar el tablero gerencial.',
  });
}
